<template>
  <v-container fluid>
    <PageHeaderSlot />
    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="filterSelected.page"
      :pageLimit.sync="filterSelected.limit"
      :itemTotal="tableItemTotal"
      enableSearch
      @search-clicked="searchKeyword($event)"
      @search-input="filterSelected.keyword = $event"
      enableAdvancedSearch
      @advanced-search-clicked="handleAdvancedSearch($event)"
      enableClearAll
      @all-search-cleared="clearSearch()"
      @refresh-clicked="refreshData()"
      enableRefresh
      @options-update="getPayTuitionData()"
      enableMultiTypeSearch
      :searchTypeOptions="searchTypeOptions"
      :searchType.sync="filterSelected.searchType"
      :initSearchKeyword="$route.query.search"
    >
      <!-- :enableConditionFilter="false"
      :conditionFilterOptions="filterOptions"
      :selectedConditions.sync="filterSelected.conditions"
      @condition-changed="onConditionFilterChanged()" -->
      <template slot="append-toolbar-left" v-if="enableConditionFilter">
        <FormSelect
          :fieldValue.sync="filterSelected.condition"
          :options="filterOptions"
          hideDetails
          placeholder="table.addFilter"
          enableClear
          @changed="onConditionFilterChanged()"
          class="mr-3 mt-2 mb-3 search-select-field persist-clear"
          enableTooltip
          :readonly="tableLoading"
        />
      </template>

      <template v-slot:[`item.student_name`]="{ item }">
        <div class="d-flex align-center">
          <div style="white-space: nowrap;">{{ item.student_name }}</div>
          <v-btn
            v-if="canViewStudent"
            icon
            depressed
            x-small
            :to="{ name: 'StudentDetails', params: { id: item.id } }"
            :disabled="!item.active"
          >
            <v-icon class="fi fi-rr-eye" size="12" color="primary"></v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.order_status`]="{ item }">
        <div class="d-flex flex-column align-center" v-if="item.order_status.length > 0">
          <v-chip
            v-for="status in item.order_status"
            class="my-1"
            :class="{
              'chip-active': status === 'expired',
              'chip-error': status === 'cancelled',
              'chip-inactive':
                status === 'pending' || status === 'null' || status === 'processing' || status === 'not_issued',
            }"
            style="width: fit-content;"
            >{{ status | formatOrderStatus }}</v-chip
          >
        </div>
        <v-chip v-else class="chip-inactive">{{ 'null' | formatOrderStatus }}</v-chip>
      </template>

      <template v-slot:[`item.next_order_status`]="{ item }">
        <div class="d-flex flex-column align-center" v-if="item.next_order_status.length > 0">
          <v-chip
            v-for="status in item.next_order_status"
            class="my-1"
            :class="{
              'chip-active': status === 'expired',
              'chip-error': status === 'cancelled',
              'chip-inactive':
                status === 'pending' || status === 'null' || status === 'processing' || status === 'not_issued',
            }"
            style="width: fit-content;"
            >{{ status | formatOrderStatus }}</v-chip
          >
        </div>
        <v-chip v-else class="chip-inactive">{{ 'null' | formatOrderStatus }}</v-chip>
      </template>

      <template v-slot:[`item.actionApplyCourse`]="{ item }">
        <FormButton isAdd text="applyCourse" :to="{ name: 'PayTuitionPayment', params: { id: item.id } }" />
      </template>

      <!-- T01 -->
      <template v-slot:[`item.score`]="{ item }">
        <div v-if="item.score && isAppMode(['T01'])" :class="`belt-color ${item.score}`"></div>
      </template>
    </Datatable>

    <!-- Modal：進階搜尋 -->
    <FormDialog
      ref="advancedFormDialog"
      formRef="advancedForm"
      title="table.advanceSearch"
      confirmBtnText="table.search"
    >
      <v-row class="ma-0">
        <v-col cols="12" sm="6" v-if="!this.gDisableStudentGrade">
          <FormSelect
            label="grade"
            :fieldValue.sync="filter.grade"
            :options="$store.getters.gradeOptions"
            placeholder="selectGrade"
            hideDetails
            enableClear
          />
        </v-col>
        <v-col cols="12" sm="6" v-if="!isAppMode(['T27'])">
          <FormInput label="studentSchool" :fieldValue.sync="filter.school" placeholder="studentSchool" hideDetails />
        </v-col>
        <v-col cols="12" sm="6">
          <FormSelect
            label="birthdayMonth"
            :fieldValue.sync="filter.birth"
            :options="birthMonthOptions"
            placeholder="birthdayMonth"
            hideDetails
            enableClear
          />
        </v-col>
        <v-col cols="12" sm="6">
          <FormDatePicker
            label="regYearMonth"
            placeholder="selectRegYearMonth"
            hideDetails
            :dateValue.sync="filter.regYearMonth"
            isYearMonthOnly
            disabledActionButtons
          />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormDialog from '@/components/FormDialog.vue'

export default {
  name: 'PayTuitionList',
  components: {
    Datatable,
    FormSelect,
    FormDatePicker,
    FormInput,
    FormDialog,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        ...(this.isAppMode(['T01']) ? [{ value: 'score', text: vm.$t('belt') }] : []),
        { value: 'student_code', text: vm.$t('studentCode') },
        ...(!this.gDisableStudentGrade ? [{ value: 'grade', text: vm.$t('grade') }] : []),
        ...(this.isAppMode(['T01']) ? [{ value: 'age', text: vm.$t('age') }] : []),
        { value: 'student_name', text: vm.$t('name') },
        ...(!this.isAppMode(['T27']) ? [{ value: 'school', text: vm.$t('studentSchool') }] : []),
        { value: 'phone', text: vm.$t('phone') },
        { value: 'reg_date', text: vm.$t('regDate') },
        ...(this.isAppMode(['T21']) ? [{ value: 'center_name', text: vm.$t('campus') }] : []),
        ...(this.$route.name === 'PayTuitionListWithStatus' || this.isAppMode(['T01'])
          ? [
              { value: 'order_status', text: vm.$t('currentMonthOrderStatus'), align: 'center' },
              { value: 'next_order_status', text: vm.$t('nextMonthOrderStatus'), align: 'center' },
            ]
          : []),
        { value: 'actionApplyCourse', text: '', align: 'end' },
      ]

      return headers
    },
    searchTypeOptions() {
      const vm = this
      let options = [
        { value: 'name', text: vm.$t('studentName') },
        { value: 'phone', text: vm.$t('phone') },
      ]

      if (this.isAppMode(['T40'])) {
        options.unshift({ value: 'student_code', text: vm.$t('studentCode') })
      } else {
        options.push({ value: 'student_code', text: vm.$t('studentCode') })
      }
      return options
    },
    birthMonthOptions() {
      const options = []
      const d = new Date()
      d.setDate(1)
      for (let i = 0; i < 12; i++) {
        d.setMonth(i)
        options.push({ value: `${this.$formatter.pad(i + 1)}`, text: this.$d(d, 'month') })
      }
      return options
    },
    filterOptions() {
      let options = []
      if (this.$route.name === 'PayTuitionListWithStatus') {
        options.push({
          value: 'currentMonthUnpaid',
          text: this.$t('currentMonthUnpaid'),
          siblings: ['notIssued', 'nextMonthUnpaid', 'nextNotIssued'],
        })

        if (this.isAppMode(['DEV', 'UAT', 'DEBUG'])) {
          // TODO: #202 remove after apply fixed
          options = [
            ...options,
            {
              value: 'notIssued',
              text: this.$t('notIssued'),
              siblings: ['currentMonthUnpaid', 'nextMonthUnpaid', 'nextNotIssued'],
            },
            {
              value: 'nextMonthUnpaid',
              text: this.$t('nextMonthUnpaid'),
              siblings: ['currentMonthUnpaid', 'notIssued', 'nextNotIssued'],
            },
            {
              value: 'nextNotIssued',
              text: this.$t('nextNotIssued'),
              siblings: ['currentMonthUnpaid', 'notIssued', 'nextMonthUnpaid'],
            },
          ]
        }
      } else {
        if (this.gEnableMonthPass) {
          options.push({ value: 'monthPass', text: this.$t('alreadyBuyMonthPass') })
        }
      }

      return options
    },
    initLimit() {
      return this.isAppMode(['T40', 'T45']) ? 20 : 10
    },
    // permission & setting
    enableConditionFilter() {
      return !this.isAppMode(['T01']) && this.filterOptions.length > 0
    },
    canViewStudent() {
      return this.$validate.allowAction('StudentDetails', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    /* 進階搜尋 */
    filter: {
      grade: '',
      school: '',
      regYearMonth: '',
      birth: '',
    },
    filterSelected: {
      keyword: '',
      searchType: 'name',
      conditions: [],
      condition: '',
      page: 1,
      limit: vm.initLimit,
      // 禁咗搜尋之後save
      grade: '',
      school: '',
      regYearMonth: '',
      birth: '',
    },
  }),
  methods: {
    async getPayTuitionData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }

      this.tableLoading = true
      this.tableData = []
      try {
        let payload = {
          filter_limit: this.filterSelected.limit,
          filter_page: this.filterSelected.page - 1,
          join_school_data: this.isAppMode(['T21']),
          filter_item: [{ key: 'status', value: 'active' }],
        }

        if (!this.gDisableStudentCenterFilter) {
          const selectedSchool = this.gfGetUserSelectedSchool()
          if (selectedSchool > -1) payload['center_id'] = selectedSchool
        }

        if (this.$validate.DataValid(this.filterSelected.keyword)) {
          const keyword = this.filterSelected.keyword.trim()

          if (this.$validate.DataValid(this.filterSelected.searchType)) {
            if (this.filterSelected.searchType === 'id') {
              if (this.$validate.regexId(keyword)) {
                const id = keyword.substring(1)
                payload['filter_item'].push({ key: 'id', value: parseInt(id) })
              } else if (this.$validate.regexNumber(keyword)) {
                payload['filter_item'].push({ key: 'id', value: parseInt(keyword) })
              }
            } else {
              payload['filter_item'].push({ key: this.filterSelected.searchType, value: keyword })
            }
          } else {
            payload['search'] = keyword
          }
        }
        if (this.$validate.DataValid(this.filterSelected.grade)) {
          payload['filter_item'].push({ key: 'grade', value: this.filterSelected.grade })
        }
        if (this.$validate.DataValid(this.filterSelected.school)) {
          payload['filter_item'].push({ key: 'school', value: this.filterSelected.school })
        }
        if (this.$validate.DataValid(this.filterSelected.regYearMonth)) {
          payload['filter_item'].push({ key: 'create_date', value: this.filterSelected.regYearMonth })
        }
        if (this.$validate.DataValid(this.filterSelected.birth)) {
          payload['filter_item'].push({ key: 'birthday', value: `-${this.filterSelected.birth}-` })
        }
        if (this.filterSelected.condition === 'monthPass') {
          payload['filter_item'].push({ key: 'with_monthly', value: '' })
        }
        // if (this.filterSelected.conditions.includes('monthPass')) {
        //   payload['filter_item'].push({ key: 'with_monthly', value: '' })
        // }

        if (this.$route.name === 'PayTuitionListWithStatus' || this.isAppMode(['T01'])) {
          if (this.isAppMode(['DEV', 'UAT']) && !this.isAppMode(['T01'])) {
            // TODO: #202
            let newPayload = {
              ...payload,
              limit: payload.filter_limit,
              page: payload.filter_page,
            }
            delete newPayload['filter_limit']
            delete newPayload['filter_page']

            // if (this.filterSelected.conditions.includes('currentMonthUnpaid')) {
            //   newPayload['filter'] = 'curr_unpaid_orders'
            // } else if (this.filterSelected.conditions.includes('notIssued')) {
            //   newPayload['filter'] = 'curr_unpaid_lessons'
            // } else if (this.filterSelected.conditions.includes('nextMonthUnpaid')) {
            //   newPayload['filter'] = 'next_unpaid_orders'
            // } else if (this.filterSelected.conditions.includes('nextNotIssued')) {
            //   newPayload['filter'] = 'next_unpaid_lessons'
            // }

            switch (this.filterSelected.condition) {
              case 'currentMonthUnpaid':
                newPayload['filter'] = 'curr_unpaid_orders'
                break
              case 'notIssued':
                newPayload['filter'] = 'curr_unpaid_lessons'
                break
              case 'nextMonthUnpaid':
                newPayload['filter'] = 'next_unpaid_orders'
                break
              case 'nextNotIssued':
                newPayload['filter'] = 'next_unpaid_lessons'
                break
            }
            await this._newGetPayTuitionDataServer(newPayload)
          } else {
            payload['with_order'] = ''
            // if (this.filterSelected.conditions.includes('currentMonthUnpaid')) {
            //   payload['with_order'] = 'extra'
            // } else if (this.filterSelected.conditions.includes('notIssued')) {
            //   payload['with_order'] = 'missing'
            // }

            switch (this.filterSelected.condition) {
              case 'currentMonthUnpaid':
                payload['with_order'] = 'extra'
                break
              case 'notIssued':
                payload['with_order'] = 'missing'
                break
            }

            this._getPayTuitionDataServer(payload)
          }
        } else {
          this._getPayTuitionDataServer(payload)
        }
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
        if (this.filterSelected.page === 1) {
          this.tableItemTotal = 0
        }
        this.tableLoading = false
      }
    },
    async _getPayTuitionDataServer(payload, count = 0) {
      if (count < 3) {
        try {
          const { total, data } = await this.$Fetcher.GetPayTuitions(payload)
          this.tableItemTotal = total
          this.tableData = data.map(this._mapTableData)
          this.tableLoading = false
          if (payload['with_order'] !== undefined) {
            await this._getNextOrderStatusList()
          }
        } catch (refresh) {
          if (refresh === true) {
            count += 1
            this._getPayTuitionDataServer(payload, count)
          } else {
            this.tableLoading = false
          }
        }
      } else {
        this.tableLoading = false
      }
    },
    async _getNextOrderStatusList() {
      const studentIds = this.tableData.map(el => el.id)
      try {
        const data = await this.$Fetcher.GenNextMonthPreviewOrderByStudentIds(studentIds)

        for (let count = 0; count < this.tableData.length; count++) {
          const found = data.find(el => el.student_id === this.tableData[count].id)
          if (found) {
            const today = this.$formatter.convertDate()
            // 本月訂單狀態 (本月或之前未比錢嘅lesson - 未開學費單)
            for (let i = 0; i < found.order_data.lesson_datas.length; i++) {
              const d = this.$formatter.convertDate(found.order_data.lesson_datas[i].date)
              if (
                d.getFullYear() < today.getFullYear() ||
                (d.getFullYear() === today.getFullYear() && d.getMonth() <= today.getMonth())
              ) {
                this.tableData[count].order_status.push('not_issued')
                break
              }
            }
            // 下月訂單狀態 (下月未比錢嘅lesson - 未開學費單)
            const nextMonth = this.$formatter.convertDate()
            nextMonth.setMonth(today.getMonth() + 1)
            for (let i = 0; i < found.order_data.lesson_datas.length; i++) {
              const d = this.$formatter.convertDate(found.order_data.lesson_datas[i].date)

              if (d.getFullYear() === nextMonth.getFullYear() && d.getMonth() === nextMonth.getMonth()) {
                this.tableData[count].next_order_status.push('not_issued')
                break
              }
            }
          }
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    _newGetPayTuitionDataServer(payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { total, data } = await this.$Fetcher.GetPayTuitionsNew(payload)
          this.tableItemTotal = total
          this.tableData = data.map(this._mapTableData)
          this.tableLoading = false
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          reject(err)
        }
      })
    },
    _mapTableData(el) {
      return {
        ...el,
        id: el.student_id,
        school: el.student_school_name,
        center_name: this.$t(el.center_name),
        // --- T01
        score: el.belt,
        age: this._getAge(el.birthday),
      }
    },

    _getAge(birthday) {
      if (this.$validate.DataValid(birthday) && this.$validate.regexDateStr(birthday)) {
        const birth = this.$formatter.convertDate(birthday)
        const today = this.$formatter.convertDate()
        let age = Math.abs(today.getFullYear() - birth.getFullYear())
        if (
          birth.getMonth() > today.getMonth() ||
          (birth.getMonth() === today.getMonth() && birth.getDate() > today.getDate())
        ) {
          age = age - 1
        }
        return age
      }

      return ''
    },
    clearFilter() {
      this.filterSelected.keyword = ''
      this.filterSelected.searchType = this.searchTypeOptions[0].value
      // this.filterSelected.conditions = []
      this.filterSelected.condition = ''
      this.filterSelected.page = 1
      this.filterSelected.grade = ''
      this.filterSelected.school = ''
      this.filterSelected.regYearMonth = ''
      this.filterSelected.birth = ''
    },
    searchKeyword(keyword) {
      this.filterSelected.page = 1
      this.tableItemTotal = 0
      this.filterSelected.keyword = keyword.trim()
      this.getPayTuitionData()
    },
    onConditionFilterChanged() {
      this.filterSelected.page = 1
      this.tableItemTotal = 0
      this.getPayTuitionData()
    },
    clearSearch() {
      this.clearFilter()
      this.tableItemTotal = 0
      this.getPayTuitionData()
    },
    refreshData() {
      this.filterSelected.limit = this.initLimit
      this.filterSelected.page = 1
      this.tableItemTotal = 0
      this.getPayTuitionData()
    },

    // -- (進階搜尋)
    async handleAdvancedSearch(allow) {
      if (!allow) return
      if (this.tableLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.$refs.advancedFormDialog.setLoading(false)
      this.filter.grade = this.filterSelected.grade
      this.filter.school = this.filterSelected.school
      this.filter.regYearMonth = this.filterSelected.regYearMonth
      this.filter.birth = this.filterSelected.birth

      const confirm = await this.$refs.advancedFormDialog.show()
      if (confirm) {
        this.filterSelected.grade = this.filter.grade
        this.filterSelected.school = this.filter.school
        this.filterSelected.regYearMonth = this.filter.regYearMonth
        this.filterSelected.birth = this.filter.birth
        this.filterSelected.page = 1
        this.tableItemTotal = 0
        this.getPayTuitionData()
        this.$refs.advancedFormDialog.hide()
      }
    },

    _getQuery() {
      this.clearFilter()
      this.filterSelected.limit = this.initLimit
      this.tableItemTotal = 0

      const query = this.gfGetTableQuery({
        searchType: 'string',
        search: 'string',
        page: 'int',
        limit: 'int',
        grade: 'string',
        school: 'string',
        date: 'year_month',
        birth: 'string',
        f: 'array_string',
        q: ['notIssued', 'currentMonthUnpaid', 'nextMonthUnpaid', 'nextNotIssued', 'monthPass'],
      })
      for (const key in this.filterSelected) {
        if (key === 'keyword') {
          if (this.$validate.DataValid(query['search'])) {
            this.$set(this.filterSelected, key, query['search'])
          }
        } else if (key === 'regYearMonth') {
          if (this.$validate.DataValid(query['date'])) {
            this.$set(this.filterSelected, key, query['date'])
          }
        } else if (key === 'conditions') {
          if (this.$validate.DataValid(query['f'])) {
            this.$set(this.filterSelected, key, query['f'])
          }
        } else if (key === 'condition') {
          if (this.$validate.DataValid(query['q'])) {
            this.$set(this.filterSelected, key, query['q'])
          }
        } else if (this.$validate.DataValid(query[key])) {
          this.$set(this.filterSelected, key, query[key])
        }
      }
      // if (this.$route.name === 'PayTuitionListWithStatus' && this.filterSelected.conditions.length < 1) {
      //   this.filterSelected.conditions.push('currentMonthUnpaid')
      // }
      if (this.$route.name === 'PayTuitionListWithStatus' && !this.filterSelected.condition) {
        this.$set(this.filterSelected, 'condition', 'currentMonthUnpaid')
      }
    },
    _regenerateURL() {
      const q = {
        searchType: this.filterSelected.searchType,
        search: this.filterSelected.keyword.trim(),
        page:
          this.filterSelected.limit !== this.initLimit || this.filterSelected.page !== 1
            ? this.filterSelected.page
            : null,
        limit:
          this.filterSelected.limit !== this.initLimit || this.filterSelected.page !== 1
            ? this.filterSelected.limit
            : null,
        grade: this.filterSelected.grade,
        school: this.filterSelected.school,
        date: this.filterSelected.regYearMonth,
        birth: this.filterSelected.birth,
        // f: this.filterSelected.conditions.length ? this.filterSelected.conditions.join(',') : null,
        q: this.filterSelected.condition,
      }

      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: PayTuitionList')
      this.userType = this.gfGetUserType()
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      await this.getPayTuitionData(false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .persist-clear {
  & .v-input__icon--clear {
    opacity: 1 !important;
  }
}
</style>
